import {React, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Card from "react-bootstrap/Card";
import { Badge, ToastService } from "@launchmetrics/lm-ui";
import Loader from 'components/Loader';
import K2Api from "lib/ajax/K2Api";


function BrandQueries(props) {
    const { voiceId } = props;
    const [loading, setLoading] = useState(true);
    const [brandQueries, setBrandQueries] = useState([]);

    useEffect(() => {
        if (voiceId) {
            const k2 = new K2Api();
            async function fetchQueries() {
                try {
                    const crawlingData = await k2.get(`/voices/${voiceId}/brandqueries`);
                    if (crawlingData && crawlingData.data) {
                        setBrandQueries(crawlingData.data.brand_queries.map((item) => item.brand_name));
                    }
                } catch (error) {
                    ToastService.show({
                        id: "voice-brandQueries-failed",
                        title: "Failed to fetch brand queries",
                        type: "error",
                    });
                    return;
                } finally {
                    setLoading(false);
                }
            };
            fetchQueries();
        }
    }, [voiceId]);

    if (loading) {
        return <Loader size={20}/>;
    }

    if (brandQueries.length === 0) {
        return null;
    }

    return (
        <Card.Body data-testid="brand-queries-body">
            <Card.Title className="details-title">WARNING</Card.Title>
            <Card.Text as="div">
                This Voice is linked to the
                {brandQueries.map((brand) => (
                    <Badge key={brand} label={brand} className="ml-1 mr-1" />
                ))}
                query! Be cautious of any change and warn the brand query team if needed.
            </Card.Text>
        </Card.Body>
    )
}

BrandQueries.propTypes = {
	voiceId: PropTypes.string
}

export default BrandQueries;
